import { NgModule } from '@angular/core';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
    TruncatePipe],
  exports: [
    TruncatePipe
    ],
    entryComponents: [],
    providers: [
        { provide: 'StorageRef', useValue: localStorage },
    ],
})
export class SharedModule {
}
